import React from 'react'
import { CircularProgress, Backdrop } from '@mui/material'
import styled from 'styled-components'
import theme from 'styles/theme'

function BackdropLoader({ open }) {
  return (
    <BackdropLoader.Backdrop open={open}>
      <CircularProgress color="inherit" />
    </BackdropLoader.Backdrop>
  )
}

BackdropLoader.Backdrop = styled(Backdrop)`
  z-index: ${theme.zIndex.backdrop} !important;
`

export default BackdropLoader
